module.exports = __webpack_public_path__ + "static/media/testimonial-brendan.c2a7cb20.png";